import { useRolesPermissions } from '../pages/rolespermissions/RolesPermissionsContext';
import { paymentRequest, show, store, update, destroy } from './constants';

function useHasPermission(module, permission = null) {
  // eslint-disable-next-line camelcase
  const { modules, permissions, isAuthenticated, loading } = useRolesPermissions();

  // If loading, return false or a loading state
  if (loading) {
    return false; // Or handle this in a way that makes sense for your application
  }

  // Check if the user is an admin
  if (isAuthenticated) {
    return true; // Admin has all permissions
  }

  // Check if modules and permissions are defined
  if (!modules || !permissions) {
    return false;
  }

  // Check if the module is included
  if (!modules.includes(module)) {
    return false;
  }

  // If a specific permission is provided, check for that
  if (permission) {
    if (!permissions[module] || !permissions[module].includes(permission)) {
      return false;
    }
  } else {
    // Additional check for module having any of the specified permissions
    const requiredPermissions =
      module === paymentRequest ? [store, show, destroy, update] : [show, destroy, update];
    const modulePermissions = permissions[module] || [];

    const hasAnyPermission = requiredPermissions.some((perm) => modulePermissions.includes(perm));
    if (!hasAnyPermission) {
      return false;
    }
  }

  return true;
}

export default useHasPermission;
